import { z } from "zod";

export const s3BucketRowSchema = z.object({
  name: z.string(),
  creationDate: z.string(),
});

export type S3BucketRow = z.infer<typeof s3BucketRowSchema>;

export const listBucketsResponseSchema = z.object({
  buckets: z.array(s3BucketRowSchema),
});

export type ListBucketsResponse = z.infer<typeof listBucketsResponseSchema>;
